import { render, staticRenderFns } from "./AttendanceArriveUpdateV2.vue?vue&type=template&id=06dda4a6&scoped=true"
import script from "./AttendanceArriveUpdateV2.vue?vue&type=script&lang=js"
export * from "./AttendanceArriveUpdateV2.vue?vue&type=script&lang=js"
import style0 from "./AttendanceArriveUpdateV2.vue?vue&type=style&index=0&id=06dda4a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dda4a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06dda4a6')) {
      api.createRecord('06dda4a6', component.options)
    } else {
      api.reload('06dda4a6', component.options)
    }
    module.hot.accept("./AttendanceArriveUpdateV2.vue?vue&type=template&id=06dda4a6&scoped=true", function () {
      api.rerender('06dda4a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/AttendanceArriveUpdateV2.vue"
export default component.exports